import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import { businessData } from '../mock';

const Footer = () => {
  return (
    <footer className="footer-classic">
      <div className="footer-container">
        <div className="footer-grid">
          {/* About */}
          <div className="footer-column">
            <h3 className="footer-heading">Herrefrisør</h3>
            <p className="footer-text">
              En klassisk herrefrisør med over 50 års erfaring.
              Kvalitet, tradition og personlig service på Nørrebro.
            </p>
          </div>

          {/* Contact */}
          <div className="footer-column">
            <h3 className="footer-heading">Kontakt</h3>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <MapPin size={16} />
                <span>
                  {businessData.address.street}<br />
                  {businessData.address.postal}
                </span>
              </div>
              <div className="footer-contact-item">
                <Phone size={16} />
                <a href={`tel:${businessData.phone}`}>{businessData.phone}</a>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div className="footer-column">
            <h3 className="footer-heading">Åbningstider</h3>
            <div className="footer-hours">
              {businessData.openingHours.map((item, index) => (
                <div key={index} className="footer-hours-row">
                  <span className="footer-day">{item.day}</span>
                  <span className="footer-time">{item.hours}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Herrefrisør. Alle rettigheder forbeholdes.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;